import parseCryptoToken from "../../../../../utils/parseCryptoToken";
import {NETWORKS_DETAILED_NAMES} from "../../../../../constants/networks";
import upperFirst from "mn-utils/upperFirst";
import toLower from "mn-utils/toLower";

export default (data) => {
  const NETWORK_SYNONYMS = {
    matic: 'Polygon'
  };

  const parsedCryptoToken = parseCryptoToken(data.cc_code);
  const BPaySymbol = 'EUR (Binance Pay)';
  const cryptoCurrencyCode = parsedCryptoToken[1] === 'EUR' ? BPaySymbol : parsedCryptoToken[1];

  const networkRaw = NETWORK_SYNONYMS[data.network] || data.network || parsedCryptoToken[0];
  const network = NETWORKS_DETAILED_NAMES[networkRaw] || upperFirst(networkRaw || '');

  return {
    refundId: data.id,
    orderId: data.order_id,

    fiatAmount: data.fiat_amount,
    fiatCode: data.fiat_code,

    assetAmount: data.currency_amount,
    assetCode: cryptoCurrencyCode,
    network,

    createdAt: data.created_at,

    hash: data.hash,
    kind: data.kind,
    email: data.email,

    status: toLower(data.status || ''),
  }
}
